const normalizeFilterValue = value => {
  const normalized = String(value || "").trim();
  return normalized || undefined;
};

export const mergeShopeeCatalogFilters = (
  current = {},
  { search = "", mappingState = "all", syncState = "all" } = {}
) => {
  const nextSearch = normalizeFilterValue(search);
  const nextMappingState =
    mappingState === "all" ? undefined : normalizeFilterValue(mappingState);
  const nextSyncState =
    syncState === "all" ? undefined : normalizeFilterValue(syncState);

  const unchanged =
    Number(current.page || 1) === 1 &&
    current.active_only === true &&
    normalizeFilterValue(current.search) === nextSearch &&
    normalizeFilterValue(current.mapping_state) === nextMappingState &&
    normalizeFilterValue(current.sync_state) === nextSyncState;

  if (unchanged) return current;

  return {
    ...current,
    page: 1,
    active_only: true,
    search: nextSearch,
    mapping_state: nextMappingState,
    sync_state: nextSyncState
  };
};
